import { render, staticRenderFns } from "./DeleteSmallConfirm.vue?vue&type=template&id=6c9caf4a&"
import script from "./DeleteSmallConfirm.vue?vue&type=script&lang=js&"
export * from "./DeleteSmallConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports